import React, { useContext, useState } from 'react'
import moment from 'moment'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Chip from '@mui/material/Chip'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { UserContext } from '../../App'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Modal,
} from '@mui/material'
import ExpandMore from '@mui/icons-material/ExpandMore'
import ShiftLine from './ShiftLine'
import RecentShiftPopup from './RecentShiftPopup'

const MyRecentShifts = ({ recentShifts, defaultExpanded }) => {
  const [expanded, setExpanded] = useState(defaultExpanded)
  const { user } = useContext(UserContext)
  const [selectedShift, setSelectedShift] = useState({})

  return (
    <Stack gap={1}>
      <Accordion expanded={expanded} disableGutters component={Paper} variant="outlined" sx={{ borderRadius: 2, '&:before': { display: 'none' } }}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          sx={{ display: 'flex' }}
          onClick={() => setExpanded(!expanded)}
        >
          <Typography variant="title2">My Recent Shifts</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 0 }}>
          {recentShifts.map((shift) => (
            <ShiftLine
              key={shift._id}
              shift={shift}
              showStatus
              onClick={() => setSelectedShift(shift)}
            />
          ))}
        </AccordionDetails>
      </Accordion>
      <Modal
        open={Object.keys(selectedShift).length > 0}
        onClose={() => setSelectedShift({})}
      >
        <RecentShiftPopup
          shift={selectedShift}
          onClose={() => setSelectedShift({})}
        />
      </Modal>
    </Stack>
  )
}

export default MyRecentShifts
